export default __webpack_public_path__ + "static/media/Elden Ring.6bc9a201.jpg";